import { cva } from "class-variance-authority";

export const tabsV2ListVariants = cva(
  "relative flex w-fit max-w-full border-b border-ui-border gap-6 overflow-x-auto [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
);

export const tabsV2TriggerVariants = cva(
  [
    "relative py-2 px-2 shrink-0",
    "text-sm font-medium text-ui-text-muted",
    "cursor-pointer select-none whitespace-nowrap",
    "transition-colors duration-200",
    "hover:text-ui-text",
    "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ui-primary focus-visible:ring-offset-2 focus-visible:rounded-sm",
    "disabled:pointer-events-none disabled:opacity-40",
    "data-[state=active]:text-ui-text-dark",
  ].join(" "),
);
